import React, { PureComponent } from 'react'

import PropTypes from 'prop-types'

import { CuratedBoxLayout } from '@features/curated-box-carousel'

import { CollectionId } from 'routes/Menu/domains/collections/constants'
import { getNumPortions } from 'selectors/basket'
import { getRecipes } from 'selectors/root'

import { DetailOverlay } from '../../components/Detail'
import { getCuratedBoxes } from '../../selectors/menuService'
import { RecipeListWrapper } from '../RecipeList'
import { RecipeGridDescription } from './RecipeGridDescription'

import css from '../../Menu.css'

class RecipeGrid extends PureComponent {
  constructor(props) {
    super(props)
    this.allRecipesCollection = CollectionId.AllRecipes
    this.state = {
      shouldShowOverlay: false,
    }
  }

  componentDidMount() {
    this.setState({ shouldShowOverlay: true })
  }

  render() {
    const { shouldShowOverlay } = this.state
    const { menuCurrentCollectionId, handleOnClickForCuratedBox, curatedBoxesMethods } = this.props
    const { getRecipeStock, isCuratedBoxEnabled } = curatedBoxesMethods
    const showCuratedBoxCarousel =
      isCuratedBoxEnabled && this.allRecipesCollection === menuCurrentCollectionId

    return (
      <div className={css.menuContainer} data-testing="menuRecipesList">
        {showCuratedBoxCarousel && (
          <CuratedBoxLayout
            handleOnClickForCuratedBox={handleOnClickForCuratedBox}
            curatedBoxesMethods={{
              getRecipeStock,
              getRecipes,
              getCuratedBoxes,
              getNumPortions,
            }}
          />
        )}
        {menuCurrentCollectionId === '97270056-cd65-11e8-a2d2-067a72dd5dba' && (
          <RecipeGridDescription
            title="Based on what you've had before"
            text="We think you'll love these recipes"
          />
        )}
        <RecipeListWrapper />
        <DetailOverlay showOverlay={shouldShowOverlay} />
      </div>
    )
  }
}

RecipeGrid.propTypes = {
  query: PropTypes.shape({
    collection: PropTypes.string,
  }),
  menuCurrentCollectionId: PropTypes.string,
  curatedBoxesMethods: PropTypes.shape({
    getRecipeStock: PropTypes.shape({
      getOutOfStockRecipeIds: PropTypes.func,
      getStockForRecipe: PropTypes.func,
      isRecipeOutOfStock: PropTypes.func,
    }),
    isCuratedBoxEnabled: PropTypes.bool,
  }),
  handleOnClickForCuratedBox: PropTypes.func,
}

RecipeGrid.defaultProps = {
  query: {},
  menuCurrentCollectionId: '',
  curatedBoxesMethods: {},
  handleOnClickForCuratedBox: () => {},
}

export { RecipeGrid }
